/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup, Card, CardHeader, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts, setCompanies, setCompanyUpdated} from '../../actions/quote'
import { toast } from 'react-toastify';

import {
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";


function Index(props) {
  const [company, setCompany] = useState('');
  const [contactData, setContactData] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  
  const main = useRef(); 
  
  useEffect(() => {
    // var userid = getuserid();
    // var role = getuserrole();
    setCompany(props.company)
  },[props.company]);

  useEffect(() => {    
    if(props.quote.contact_updated || props.quote.company_updated){
      setEditMode(false);
    }
  },[props.quote.contact_updated, props.quote.company_updated]);

  const getuserid=()=>{
    var userid = null;
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
      console.log('getuser', userinfo);
      if(role == 'admin'){
        userid = props.selectedUser
      }
      else{
        userid = userinfo['id'];
      }
    }
    return userid;
  }


  const addTrigerCompany = (e)=>{
    if(props.onChangeCompany)
      props.onChangeCompany([])
    setCompany(null)
    toggleEditMode();
  }
  const toggleEditMode = ()=>{
    setEditMode(!editMode);
  }

  const deleteCompany = ()=>{
    props.setCompanyUpdated(false)
    axios.post(`/companies/delete/${company.id}`, {}).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your company has been deleted"); 
        setCompany(null)
        props.onChangeCompany([])
        setDeleteConfirm(false)
        props.setCompanyUpdated(true)
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  return (
    <>
      <div className="bg-transparent border-0">
          <Row>
            <Col md="12">
              <div className="">
                <Form role="form">
                  <Row>
                    <Col md="8">
                      <FormGroup className="mb-1">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Company Name" type="text" name="company" value={company?company.company:''} onChange={(e)=>setCompany({...company, company:e.target.value})}/>

                      </FormGroup>
                    </Col>
                    {props.role=="admin"&&
                    <Col md="4" className="d-flex align-items-center">
                        <div onClick={(e)=>addTrigerCompany(e)} className="d-flex align-items-center cursor-pointer">
                          <i style={{fontSize:19, marginTop:1}} className="fa fa-plus-square-o cursor-pointer mr-1" aria-hidden="true"></i>
                          <span style={{fontSize:14}}>New </span>
                        </div>
                    </Col>
                    }
                  </Row>
                  <hr/>
                  <Row>
                    <Col md="6">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Contact Number" type="text" name="phone"  value={company?company.phone:''} onChange={(e)=>setCompany({...company, phone:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Web" type="text" name="web"  value={company?company.web:''} onChange={(e)=>setCompany({...company, web:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="8">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Email" type="email" name="email"  value={company?company.email:''} onChange={(e)=>setCompany({...company, email:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Street" type="text" name="address"  value={company?company.address:''} onChange={(e)=>setCompany({...company, address:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Suburb" type="text" name="suburb"  value={company?company.suburb:''} onChange={(e)=>setCompany({...company, suburb:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="State" type="text" name="state"  value={company?company.state:''} onChange={(e)=>setCompany({...company, state:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Post Code" type="text" name="postcode"  value={company?company.postcode:''} onChange={(e)=>setCompany({...company, postcode:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  {props.role=="admin"&&
                  <Row>
                    <Col md="8">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Referral" type="text" name="referral" value={company?company.referral:''} onChange={(e)=>setCompany({...company, referral:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  }
                  {props.mode!='view'&&
                  <Row className="mt-2">
                    <Col md="6">
                      <div onClick={(e)=>toggleEditMode()} className="d-flex align-items-center cursor-pointer">
                        <i style={{fontSize:18, marginTop:1}} className="fa fa-pencil cursor-pointer mr-1" aria-hidden="true"></i>
                        <span style={{fontSize:14}}>Edit</span>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="text-right">
                        <i onClick={(e)=>{props.updateCompany(company); }}  style={{fontSize:18, marginTop:1}} className="fa fa-save cursor-pointer mr-2" aria-hidden="true"></i>
                        {props.role=="admin"&&company && company.id &&
                        <i onClick={(e)=>{setDeleteConfirm(true) }}  style={{fontSize:18, marginTop:1}} className="fa fa-trash cursor-pointer" aria-hidden="true"></i>
                        }
                      </div>
                    </Col>
                  </Row>
                  }
                </Form>
              </div>
            </Col>
          </Row>
      </div>
      {props.role=="admin"&&
      <Modal isOpen={deleteConfirm} toggle={()=>setDeleteConfirm(false)} >
        <ModalHeader toggle={()=>setDeleteConfirm(false)}>Confirm</ModalHeader>
        <ModalBody>
          Are you sure to delete this company?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={()=>deleteCompany(false)}>Yes</Button>{' '}
          <Button color="secondary" size="sm" onClick={()=>setDeleteConfirm(false)}>No</Button>
        </ModalFooter>
      </Modal>
      }
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    setCompanies: companies=>dispatch(setCompanies(companies)),
    setCompanyUpdated: value=>dispatch(setCompanyUpdated(value)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
